// extracted by mini-css-extract-plugin
export default {"wrapper":"AdCJe9_"};